import React from 'react'
import { IndexRoute, Route } from 'react-router'

import Settings from '../components/settings/list'
import HomepageSlug from '../components/settings/HomepageSlug'
import SessionSaleDefaultPlanCode from '../components/settings/SessionSaleDefaultPlanCode'
import GlobalCSS from '../components/settings/GlobalCSS'
import DefaultInstitutionHtmlBlock from '../components/settings/DefaultInstitutionHtmlBlock'
import ServicesMenu from '../components/settings/ServicesMenu'
import AboutUsMenu from '../components/settings/AboutUsMenu'
import ResourcesMenu from '../components/settings/ResourcesMenu'
import RedirectConfig from '../components/settings/RedirectConfig'
import * as MailChimp from '../components/settings/MailChimp'
import ProfileFieldConfig from '../components/settings/ProfileFieldConfig'
import Universities from '../components/settings/universities/list'
import CreateUniversity from '../components/settings/universities/create'
import EditUniversity from '../components/settings/universities/edit'
import Affirmations from '../components/settings/Affirmations'
import InvoiceAddress from '../components/settings/InvoiceAddress'
import SessionExpiration from '../components/settings/SessionExpiration'

const CmsRoutes = (
  <Route path='settings'>
    <IndexRoute component={Settings} />
    <Route path='homepage_slug' component={HomepageSlug} />
    <Route path='session_sale_default_plan_code' component={SessionSaleDefaultPlanCode} />
    <Route path='global_css' component={GlobalCSS} />
    <Route path='default_institution_html_block' component={DefaultInstitutionHtmlBlock} />
    <Route path='session_expiration_in_hours' component={SessionExpiration} />
    <Route path='services_menu' component={ServicesMenu} />
    <Route path='about_us_menu' component={AboutUsMenu} />
    <Route path='resources_menu' component={ResourcesMenu} />
    <Route path='redirects' component={RedirectConfig} />
    <Route path='affirmations' component={Affirmations} />
    <Route path='invoice_address' component={InvoiceAddress} />
    <Route path='mailchimp_list_id' component={MailChimp.ListId} />
    <Route path='mailchimp_embed_code' component={MailChimp.EmbedCode} />
    <Route path='mailchimp_usertype_mapping' component={MailChimp.UsertypeMapping} />
    <Route path='mailchimp_default_interests' component={MailChimp.DefaultInterests} />
    <Route path='profile_fields/title' component={props => <ProfileFieldConfig {...props} field='titles' />} />
    <Route path='profile_fields/discipline' component={props => <ProfileFieldConfig {...props} field='disciplines' />} />
    <Route path='profile_fields/discipline_classification' component={props => <ProfileFieldConfig {...props} field='discipline_classifications' />} />
    <Route
      path='profile_fields/post_nominal_letter'
      component={props => <ProfileFieldConfig {...props} field='post_nominal_letters' />}
    />
    <Route path='profile_fields/gender' component={props => <ProfileFieldConfig {...props} field='genders' />} />
    <Route path='profile_fields/ethnicity' component={props => <ProfileFieldConfig {...props} field='ethnicities' />} />
    <Route path='universities'>
      <IndexRoute component={Universities} />
      <Route path='create' component={CreateUniversity} />
      <Route path=':universityId/edit' component={EditUniversity} />
    </Route>
  </Route>
)

export default CmsRoutes
